<app-semester-select 
    [showInAttendanceOnly]="true"
    [showInCoursesOnly]="true"
    (onClick)="onSemesterSelect($event)">
</app-semester-select>
